module.exports = __webpack_public_path__ + "static/media/Monday_Step3_Image13.379a62fa.webp";